import { render, staticRenderFns } from "./PasswordRecoveryComplete.vue?vue&type=template&id=7ae69221&lang=pug&"
import script from "./PasswordRecoveryComplete.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports